<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('LANGNAME')">
        <inputvalidation :formerror="formError" name="langName">
          <b-form-input type="text" v-model="formData.langName"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('LANGCODE')">
        <inputvalidation :formerror="formError" name="langCode">
          <b-form-input type="text" v-model="formData.langCode"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'AclGroups',
    props: ['formData', 'formError'],
};
</script>
